// extracted by mini-css-extract-plugin
export default {"item":"TcO1c1l5QdJuppzgAEw0","divider":"e4ipxz1NUPiZQgTdRMXW"};